import React from 'react'
import ActionUnavailable from 'src/app/ActionUnavailable/ActionUnavailable'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { actionUnavailableRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const ActionUnavailableAppRoute: AppRoute = {
  id: AppLocation.ActionUnavailable,
  routeProps: actionUnavailableRouteProps,
  component: <ActionUnavailable />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ActionUnavailableAppRoute
